'use client';

import { BlockData } from '@bw/apis/contentful';
import { BlockFactory } from './BlockFactory';
import { livePreviewBlockMap } from './livePreviewBlockMap';

export const LivePreviewBlockFactory = (props: {
	data: BlockData | BlockData[];
}) => <BlockFactory blockMap={livePreviewBlockMap} data={props.data} />;
